
import 'components/catalog.tag'
import 'pages/products/parameters/parameter-group-new-modal.tag'
riot.tag2('parameters-groups-list', '  <catalog object="FeatureGroup" cols="{cols}" search="true" add="{permission(addEdit , &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(addEdit, &quot;products&quot;, &quot;1000&quot;)}" reorder="true" reload="true" store="parameters-groups-list">\n    <yield to="body">\n      <datatable-cell name="id" style="width: 5%;">{row.id}</datatable-cell>\n      <datatable-cell name="img" style="width: 100px;"><img if="{row.imageUrlPreview.trim() !== &quot;&quot;}" riot-src="{row.imageUrlPreview}" style="max-height: 32px;"></datatable-cell>\n      <datatable-cell name="name" style="width: 20%;">{row.name}</datatable-cell>\n      <datatable-cell name="description">{row.description}</datatable-cell>\n      <datatable-cell name="sort" style="width: 2%;">{row.sort}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'FeatureGroup';

self.cols = [{ name: 'id', value: '#' }, { name: 'img', value: 'Фото' }, { name: 'name', value: 'Наименование' }, { name: 'description', value: 'Описание' }, { name: 'sort', value: 'Индекс' }];

self.addEdit = function (e) {
    var id;
    if (e.item && e.item.row) {
        id = e.item.row.id;
    }

    modals.create('parameter-group-new-modal', {
        type: 'modal-primary',
        id: id,
        submit: function submit() {
            var _this = this;
            var params = _this.item;

            _this.error = _this.validation.validate(_this.item, _this.rules);

            if (!_this.error) {
                API.request({
                    object: 'FeatureGroup',
                    method: 'Save',
                    data: params,
                    success: function success(response) {
                        _this.modalHide();
                        self.tags.catalog.reload();
                    }
                });
            }
        }
    });
};

self.one('updated', function () {
    self.tags.catalog.tags.datatable.on('reorder-end', function () {
        var _self$tags$catalog$pa = self.tags.catalog.pages,
            current = _self$tags$catalog$pa.current,
            limit = _self$tags$catalog$pa.limit;

        var params = { indexes: [] };
        var offset = current > 0 ? (current - 1) * limit : 0;

        self.tags.catalog.items.forEach(function (item, sort) {
            item.sort = sort + offset;
            params.indexes.push({ id: item.id, sort: sort + offset });
        });

        API.request({
            object: 'FeatureGroup',
            method: 'Sort',
            data: params,
            notFoundRedirect: false
        });

        self.update();
    });
});

observable.on('parameters-groups-reload', function () {
    self.tags.catalog.reload();
});
});


// WEBPACK FOOTER //
// ./pages/products/parameters/parameters-groups-list.tag